import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import AdminLeads from "@/pages/AdminLeads";
import AdminLogin from "@/pages/AdminLogin";
import CityLandingPage from "@/pages/CityLandingPage";
import CityServicePage from "@/pages/CityServicePage";
import ServiceAreasPage from "@/pages/ServiceAreasPage";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/service-areas" element={<ServiceAreasPage />} />
            <Route path="/service-areas/:citySlug" element={<CityLandingPage />} />
            <Route path="/service-areas/:citySlug/:serviceSlug" element={<CityServicePage />} />
            {/* Backward-compat redirects for the old /plumbing/... URLs */}
            <Route path="/plumbing/:citySlug" element={<LegacyCityRedirect />} />
            <Route path="/plumbing/:citySlug/:serviceSlug" element={<LegacyCityServiceRedirect />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/leads"
              element={
                <ProtectedRoute>
                  <AdminLeads />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

function LegacyCityRedirect() {
  // Preserves the city slug when redirecting from /plumbing/:city to /service-areas/:city
  const path = window.location.pathname.replace(/^\/plumbing\//, "/service-areas/");
  return <Navigate to={path} replace />;
}
function LegacyCityServiceRedirect() {
  const path = window.location.pathname.replace(/^\/plumbing\//, "/service-areas/");
  return <Navigate to={path} replace />;
}

export default App;
